// import styles from "./Popover.module.scss";
import React from "react";
import Confetti from "react-dom-confetti";
import classnames from "classnames";

export interface Props {
    children: string | JSX.Element | (string | JSX.Element)[];
    confetti?: boolean;
    onClose?: () => void;
    style?: any;
    top?: string;
    left?: string;
    topLeftPointLeft?: boolean;
}

export interface State {
    confetti: boolean;
}

export default class Popover extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            confetti: false,
        };

        if (this.props.confetti) {
            setTimeout(() => {
                this.setState({
                    confetti: true,
                });
            }, 0);
        }
    }

    render() {
        const confetti = {
            angle: 360,
            spread: 560,
            startVelocity: 20,
            elementCount: 500,
            decay: 0.90,
        };
        const style = this.props.style || {};

        if (this.props.top) {
            style.top = this.props.top;
            style.transform = "translate(0%, 0%)";
        }
        if (this.props.left) {
            style.left = this.props.left;
            style.transform = "translate(0%, 0%)";
        }

        const classes = classnames({
            popover: true,
            "top-left-point-left": this.props.topLeftPointLeft,
        });

        return (
            <div className={classes} style={style}>
                {this.props.onClose ? <button onClick={this.props.onClose}>X</button> : null}
                <div className="confetti">
                    <Confetti active={this.state.confetti} config={confetti} />
                </div>
                {this.props.children}
            </div>
        );
    }
};
